export default __webpack_public_path__ + "static/media/step-two-keeper.0b0980e4.jpg";